export const gitCommit = 'c7e86e0a'
